import { createFileRoute } from '@tanstack/react-router';
import { PlannerPlaceholder } from '../components/PlannerPlaceholder.js';
import { RequireMeasurements } from '../components/RequireMeasurements.js';

export const Route = createFileRoute('/_planner/planner/review')({
  component: () => (
    <RequireMeasurements requireLock currentIndex={4}>
      <PlannerPlaceholder id="review" />
    </RequireMeasurements>
  ),
});
